import { ReactElement } from 'react';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { PublishedProjectInfoContainer } from '../../../modules/projectDetails/containers/PublishedProjectInfo.container';
import { AnnotationTypesListContainer } from '../../../modules/projectDetails/sub/tools/containers/AnnotationTypesList.container';
import { AttributesListContainer } from '../../../modules/projectDetails/sub/tools/containers/AttributesList.container';
import { QuestionsListContainer } from '../../../modules/projectDetails/sub/tools/containers/QuestionsList.container';

export const ProjectDetailsAnnotationToolsView = (): ReactElement => (
  <ColumnLayout size='md'>
    <PublishedProjectInfoContainer />
    <ColumnLayout size='l'>
      <AnnotationTypesListContainer />
      <AttributesListContainer />
      <QuestionsListContainer />
    </ColumnLayout>
  </ColumnLayout>
);
